const SIX_HOURS_IN_MSEC = Object.freeze(1000 * 60 * 60 * 6);

export const bankAccountMapper = (bankAccount) => {
  if (!bankAccount.createdAt) {
    bankAccount.editable = false;
    return bankAccount;
  }

  const createdAtDate = new Date(bankAccount.createdAt);

  if (+createdAtDate < new Date() - SIX_HOURS_IN_MSEC) {
    bankAccount.editable = false;
  } else {
    bankAccount.editable = true;
  }

  if (
    Object.prototype.hasOwnProperty.call(
      bankAccount,
      "details_zar_identification_number"
    )
  ) {
    bankAccount.detailsZarIdentificationNumber =
      bankAccount.details_zar_identification_number;
  }

  return bankAccount;
};
